export default function About() {
    return (
      <div className="container">
        <h1>Technology and Business Solutions</h1>
        <p>
          Red30 Tech is the leading source of secure, fully customizable
          technology and business solutions. We cater to those who need scalable
          results that are sustainable for their company and the planet. With the
          ever-evolving technology landscape, we want to be your go-to source for
          business technology.
        </p>
        <p>
          Our mission is to provide technology and business-driven solutions that
          work seamlessly with your company, allowing your employees, partners,
          and customers to engage in quality interactions that lead to scalable
          growth. We consistently work towards being the premier provider of
          environmentally sustainable technology solutions that connect the world.
        </p>
      </div>
    );
  }